import { configureStore } from "@reduxjs/toolkit";

import authReducer from "./slices/authSlice";
import { recordApi } from "./services/recordApi";
import { allocationApi } from "./services/allocationApi";
import { phoneTemplateApi } from "./services/phoneTemplateApi";
import { vehicleApi } from "./services/vehicleApi";
import { driverApi } from "./services/driverApi";
import { productApi } from "./services/productApi";
import { pickupApi } from "./services/pickupApi";
import { releaseApi } from "./services/releaseApi";
import { distributionApi } from "./services/distribution";

export const store = configureStore({
	reducer: {
		auth: authReducer,
		[recordApi.reducerPath]: recordApi.reducer,
		[allocationApi.reducerPath]: allocationApi.reducer,
		[phoneTemplateApi.reducerPath]: phoneTemplateApi.reducer,
		[vehicleApi.reducerPath]: vehicleApi.reducer,
		[driverApi.reducerPath]: driverApi.reducer,
		[productApi.reducerPath]: productApi.reducer,
		[pickupApi.reducerPath]: pickupApi.reducer,
		[releaseApi.reducerPath]: releaseApi.reducer,
		[distributionApi.reducerPath]: distributionApi.reducer,
	},
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware().concat(
			recordApi.middleware,
			allocationApi.middleware,
			phoneTemplateApi.middleware,
			vehicleApi.middleware,
			driverApi.middleware,
			productApi.middleware,
			pickupApi.middleware,
			releaseApi.middleware,
			distributionApi.middleware
		),
	devTools: true,
});
